import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Shops from './pages/Shops';
import ShopCategories from './pages/ShopCategories';
import Products from './pages/Products';
import ProductCategories from './pages/ProductCategories';
import Companies from './pages/Companies';
import ShopProducts from './pages/ShopProducts';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="shops" element={<Shops />} />
        <Route path="shop-categories" element={<ShopCategories />} />
        <Route path="products" element={<Products />} />
        <Route path="product-categories" element={<ProductCategories />} />
        <Route path="companies" element={<Companies />} />
        <Route path="shop-products" element={<ShopProducts />} />
      </Route>
    </Routes>
  );
}

export default App;